/**
 * 전역 알림(토스트) 단일 진입점 — sonner 래핑. 컴포넌트는 sonner 를 직접 import 하지 않는다.
 * 에러 토스트 출처는 API 계층(에러 인터셉터) 단일 — 화면이 같은 에러를 중복으로 띄우지 않는다.
 */
import { toast } from 'sonner';

/** 토스트에 붙는 행동 1개(예: 되돌리기, specs/069). */
export interface NotifyAction {
  label: string;
  onClick: () => void;
}

export const notify = {
  /** 행동(되돌리기 등)이 붙으면 누를 시간을 주려고 8초 동안 띄운다. */
  success: (message: string, description?: string, action?: NotifyAction) =>
    toast.success(message, { description, action, ...(action ? { duration: 8000 } : {}) }),
  error: (message: string, description?: string) => toast.error(message, { description }),
  info: (message: string, description?: string) => toast.info(message, { description }),
  warning: (message: string, description?: string) => toast.warning(message, { description }),
};
